import { createContext, useContext } from "react";

import { ConfirmationDialogContextValue } from "./ConfirmationDialogContextProvider.types";

const defaultValue: ConfirmationDialogContextValue = {
  showConfirmationDialog: () => "",
  showOkDialog: () => {},
  showYesNoDialog: () => {},
};

export const ConfirmationDialogContext = createContext<ConfirmationDialogContextValue>(defaultValue);
export const useConfirmationDialogContext = (): ConfirmationDialogContextValue => useContext(ConfirmationDialogContext);
